import PropTypes from "prop-types";
import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

const messages = defineMessages({
  submitVehicleNumber: {
    id: "modules.Malfunctions.components.VehicleForm.submit",
    description: "Submit label",
    defaultMessage: "Fetch pending malfunctions",
  },
  enterVehicleNumber: {
    id: "modules.Malfunctions.components.VehicleForm.enter",
    description: "Enter label",
    defaultMessage: "Enter vehicle-number",
  },
});

const VehicleForm = ({
  handleChange,
  handleSubmit,
  values,
  errors,
  isSubmitting,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="align-items-center">
        <Col xs={12} md={6}>
          <Form.Group controlId="vehicleNumber">
            <Form.Control
              type="text"
              autoComplete="off"
              onChange={handleChange}
              value={values.vehicleNumber || ""}
              placeholder={formatMessage(messages.enterVehicleNumber)}
            />
          </Form.Group>
        </Col>
        <Col xs={12} md={6}>
          <Button
            type="submit"
            disabled={isSubmitting || Object.keys(errors).length > 0}
            variant="primary"
            block
          >
            <FormattedMessage {...messages.submitVehicleNumber} />
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

VehicleForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isSubmitting: PropTypes.bool.isRequired,
};

export default VehicleForm;
